// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)
export const asyncLanguages: Record<string, () => unknown> = {
	en: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-root-i18n-en" */ '../../../i18n/en'
		),
};
